// removed by extract-text-webpack-plugin
module.exports = {"cardWarp":"components-changeMajorStaic-index-cardWarp-rEoCg","title":"components-changeMajorStaic-index-title-tGqsm","titleCenter":"components-changeMajorStaic-index-titleCenter-39khK","count":"components-changeMajorStaic-index-count-3nrR7","extraTitle":"components-changeMajorStaic-index-extraTitle-3n863","warpFlex":"components-changeMajorStaic-index-warpFlex-2mh7j","rightFilter":"components-changeMajorStaic-index-rightFilter-1neMz","rightFilter_select":"components-changeMajorStaic-index-rightFilter_select-1gn97","warpRight":"components-changeMajorStaic-index-warpRight-19s3H"};


//////////////////
// WEBPACK FOOTER
// ./components/changeMajorStaic/index.css
// module id = 361
// module chunks = 0